import React from 'react';
import { HashRouter, Route } from 'react-router-dom';

import { SupraLogo } from 'components/SideMenu/StyledComponents';
import styled from 'styled-components';
import * as SingleAccessSetupView from './pages/SingleAccessSetupView';
import { AppErrorBoundary } from '../components';
import { SingleAccessSetupContextProvider } from './context/SingleAccessSetupContext';
import BrokerAndAgentHero from '../../img/BrokerAndAgentHero.svg';

const SingleAccessRouter = () => (
  <HashRouter>
    <SingleAccessSetupContextProvider>
      <AppErrorBoundary>
        <StyledLayout>
          <SupraLogo $logoWidth="131px" />
          <Route
            path="/setup/:hash"
            component={SingleAccessSetupView.default}
          />
        </StyledLayout>
      </AppErrorBoundary>
    </SingleAccessSetupContextProvider>
  </HashRouter>
);

export default SingleAccessRouter;

const StyledLayout = styled.div`
  display: flex;
  background-color: white;
  height: 100vh;
  height: 100dvh;
  flex-direction: column;
  background-image: url(${BrokerAndAgentHero});
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: contain;
`;
